<template>
  <div>
    <!-- Header -->
    <div class="content-header">
      <div class="content-header-left">
        <div class="content-header-title">
          <h2 class="content-title">Detalle del Contacto</h2>
          <p class="content-subtitle">Información completa del contacto</p>
        </div>
      </div>
      <div class="content-header-right">
        <b-button
          variant="outline-secondary"
          class="mr-2"
          @click="$router.push({ name: 'contactos-lista' })"
        >
          <feather-icon icon="ArrowLeftIcon" class="mr-50" />
          Volver a la Lista
        </b-button>
        <b-button
          variant="primary"
          @click="editarContacto"
        >
          <feather-icon icon="EditIcon" class="mr-50" />
          Editar Contacto
        </b-button>
      </div>
    </div>

    <!-- Loading -->
    <div v-if="loading && !contacto" class="text-center py-5">
      <b-spinner class="mr-2"></b-spinner>
      <span>Cargando contacto...</span>
    </div>

    <!-- Contact Details -->
    <div v-else-if="contacto">
      <b-row>
        <!-- Información Personal -->
        <b-col md="6">
          <b-card class="mb-4">
            <template #header>
              <h5 class="mb-0">
                <feather-icon icon="UserIcon" class="mr-2" />
                Información Personal
              </h5>
            </template>
            
            <div class="contact-info">
              <div class="contact-avatar mb-3">
                <b-avatar
                  :text="getInitials(contacto.nombre)"
                  variant="primary"
                  size="4rem"
                />
                <div class="ml-3">
                  <h4 class="mb-1">{{ contacto.nombre }}</h4>
                  <p class="text-muted mb-0">{{ contacto.cargo || 'Sin cargo especificado' }}</p>
                </div>
              </div>

              <div class="contact-details">
                <div v-if="contacto.telefono" class="contact-item mb-3">
                  <feather-icon icon="PhoneIcon" class="mr-2 text-primary" />
                  <span>{{ contacto.telefono }}</span>
                </div>
                
                <div v-if="contacto.email" class="contact-item mb-3">
                  <feather-icon icon="MailIcon" class="mr-2 text-primary" />
                  <a href="#" @click.prevent="enviarEmail" class="text-decoration-none text-primary" style="cursor: pointer;">
                    {{ contacto.email }}
                  </a>
                </div>
                
                <div v-if="contacto.linkedin" class="contact-item mb-3">
                  <feather-icon icon="ExternalLinkIcon" class="mr-2 text-primary" />
                  <a :href="normalizarLinkedInUrl(contacto.linkedin)" target="_blank" rel="noopener noreferrer" class="text-decoration-none">
                    Ver perfil de LinkedIn
                  </a>
                </div>
              </div>
            </div>
          </b-card>
        </b-col>

        <!-- Información de Empresa -->
        <b-col md="6">
          <b-card class="mb-4">
            <template #header>
              <h5 class="mb-0">
                <feather-icon icon="BriefcaseIcon" class="mr-2" />
                Información de Empresa
              </h5>
            </template>
            
            <div v-if="(contacto.empresa && contacto.empresa.nombre) || contacto.nombreEmpresa" class="empresa-info">
              <div class="empresa-header mb-3">
                <h6 class="mb-1">{{ contacto.empresa?.nombre || contacto.nombreEmpresa }}</h6>
                <small class="text-muted">Empresa asociada</small>
              </div>
              
              <b-button
                variant="outline-primary"
                size="sm"
                @click="verEmpresa"
              >
                <feather-icon icon="EyeIcon" class="mr-1" />
                Ver Empresa
              </b-button>
            </div>
            <div v-else class="text-muted">
              <feather-icon icon="AlertCircleIcon" class="mr-2" />
              Sin empresa asociada
            </div>
          </b-card>

          <!-- Observaciones -->
          <b-card v-if="contacto.observaciones">
            <template #header>
              <h5 class="mb-0">
                <feather-icon icon="FileTextIcon" class="mr-2" />
                Observaciones
              </h5>
            </template>
            
            <p class="mb-0">{{ contacto.observaciones }}</p>
          </b-card>
        </b-col>
      </b-row>

      <!-- Acciones -->
      <b-card>
        <template #header>
          <h5 class="mb-0">
            <feather-icon icon="SettingsIcon" class="mr-2" />
            Acciones
          </h5>
        </template>
        
        <div class="d-flex flex-wrap gap-2">
          <b-button
            variant="primary"
            @click="editarContacto"
          >
            <feather-icon icon="EditIcon" class="mr-1" />
            Editar Contacto
          </b-button>
          
          <b-button
            variant="outline-info"
            @click="enviarEmail"
            :disabled="!contacto.email"
          >
            <feather-icon icon="MailIcon" class="mr-1" />
            Enviar Email
          </b-button>
          
          
          
          <b-button
            variant="outline-warning"
            @click="abrirLinkedIn"
            :disabled="!contacto.linkedin"
          >
            <feather-icon icon="ExternalLinkIcon" class="mr-1" />
            Ver LinkedIn
          </b-button>
          
          <b-dropdown
            variant="outline-danger"
            text="Eliminar"
            class="ml-auto"
          >
            <b-dropdown-item
              variant="danger"
              @click="eliminarContacto"
            >
              <feather-icon icon="TrashIcon" class="mr-1" />
              Eliminar Contacto
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </b-card>
    </div>

    <!-- Error -->
    <div v-else class="text-center py-5">
      <feather-icon icon="AlertCircleIcon" size="48" class="text-danger mb-3" />
      <h5>Contacto no encontrado</h5>
      <p class="text-muted">El contacto que buscas no existe o ha sido eliminado.</p>
      <b-button
        variant="primary"
        @click="$router.push({ name: 'contactos-lista' })"
      >
        Volver a la Lista
      </b-button>
    </div>
 

  <!-- Modal Enviar Correo -->
  <b-modal
    id="modal-enviar-correo"
    ref="modalEnviarCorreo"
    title="Enviar Correo"
    size="lg"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    @show="onModalShow"
    @hidden="onModalHidden"
  >
    <div v-if="contacto">
      <b-alert variant="info" show class="mb-3">
        <div class="d-flex align-items-center">
          <feather-icon icon="UserIcon" size="16" class="mr-2" />
          <div>
            <strong>{{ contacto.nombre }}</strong>
            <br>
            <small>{{ contacto.email }}</small>
          </div>
        </div>
      </b-alert>

      <b-form @submit.prevent="procesarEnvio">
        <!-- Redacción libre cuando no hay plantilla seleccionada -->
        <b-card v-if="!plantillaSeleccionada" class="mb-2" body-class="pt-1">
          <b-alert variant="secondary" show class="py-1 mb-2">
            Redacción libre (sin plantilla)
          </b-alert>
          <b-form-group label="Asunto" label-for="asunto-libre">
            <b-form-input id="asunto-libre" v-model="asuntoLibre" placeholder="Asunto del correo" />
          </b-form-group>
          <b-form-group label="Contenido">
            <quill-editor v-model="contenidoLibre" :options="editorOptions" style="height: 220px;" />
          </b-form-group>
          <b-form-group label="Adjuntos (opcional)">
            <input
              type="file"
              multiple
              class="form-control"
              @change="onFilesSelectedLibre"
              accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.txt,.csv,.zip"
            />
            <div v-if="adjuntosLibres.length" class="mt-2">
              <small class="text-muted">{{ adjuntosLibres.length }} archivo(s) seleccionados</small>
              <ul class="mb-0 mt-1">
                <li v-for="(f, i) in adjuntosLibres" :key="i">{{ f.name }}</li>
              </ul>
              <b-button size="sm" variant="outline-danger" class="mt-1" @click="limpiarAdjuntosLibre">Limpiar</b-button>
            </div>
          </b-form-group>
        </b-card>

        <b-tabs content-class="mt-2">
          <!-- Tab de Plantilla -->
          <b-tab title="Plantilla" active>
            <b-form-group label="Seleccionar Plantilla">
              <v-select
                v-model="plantillaSeleccionada"
                :options="plantillasActivas"
                label="nombre"
                placeholder="Seleccionar plantilla..."
                @input="onPlantillaSeleccionada"
              />
            </b-form-group>
          </b-tab>

          <!-- Tab de Variables -->
          <b-tab title="Variables" :disabled="!plantillaSeleccionada">
            <div v-if="variablesPlantilla.length > 0">
              <b-form-group
                v-for="v in variablesPlantilla"
                :key="v.id"
                :label="v.label || v.key"
                :label-for="`var_${v.id}`"
              >
                <b-form-input
                  :id="`var_${v.id}`"
                  v-model="valoresVariables[v.key]"
                  :placeholder="`Valor para ${v.label || v.key}`"
                />
              </b-form-group>
            </div>
            <b-alert v-else variant="info" show>
              Esta plantilla no tiene variables personalizables.
            </b-alert>
          </b-tab>

          <!-- Tab de Adjuntos -->
          <b-tab title="Adjuntos" :disabled="!plantillaSeleccionada">
            <b-form-group label="Archivos Adjuntos">
              <input
                ref="fileInput"
                type="file"
                multiple
                class="form-control"
                @change="onFilesSelected"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png"
              />
              <small class="form-text text-muted">
                Puedes seleccionar múltiples archivos. Formatos permitidos: PDF, DOC, DOCX, XLS, XLSX, JPG, JPEG, PNG
              </small>
            </b-form-group>

            <div v-if="archivosAdjuntos.length > 0" class="mt-3">
              <h6>Archivos seleccionados:</h6>
              <div class="d-flex flex-wrap gap-2">
                <b-badge
                  v-for="(archivo, index) in archivosAdjuntos"
                  :key="index"
                  variant="secondary"
                  class="d-flex align-items-center"
                >
                  {{ archivo.name }}
                  <feather-icon
                    icon="XIcon"
                    size="12"
                    class="ml-1 cursor-pointer"
                    @click="eliminarArchivo(index)"
                  />
                </b-badge>
              </div>
              <b-button
                variant="outline-danger"
                size="sm"
                class="mt-2"
                @click="limpiarArchivos"
              >
                Limpiar todos
              </b-button>
            </div>
          </b-tab>

          <!-- Tab de Vista Previa -->
          <b-tab title="Vista Previa" :disabled="!plantillaSeleccionada">
            <div v-if="plantillaSeleccionada">
              <h6>Asunto:</h6>
              <p class="border p-2 rounded">{{ asuntoProcesado }}</p>
              <h6>Contenido:</h6>
              <div class="border p-2 rounded" v-html="contenidoProcesado"></div>
            </div>
          </b-tab>
        </b-tabs>
      </b-form>
    </div>

    <template #modal-footer>
      <b-button variant="secondary" @click="cerrarModal">
        Cancelar
      </b-button>
      <b-button
        variant="primary"
        @click="procesarEnvio"
        :disabled="enviando || (!plantillaSeleccionada && (!asuntoLibre || !contenidoLibre))"
      >
        <b-spinner v-if="enviando" small class="mr-1" />
        {{ enviando ? 'Enviando...' : 'Enviar Correo' }}
      </b-button>
    </template>
  </b-modal>
  </div>
</template>

<script>
import { ContactoService } from '@/services/contactoService'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import plantillaCorreoService from '@/services/plantillaCorreoService'

export default {
  name: 'ContactosDetalle',
  components: { quillEditor, vSelect },
  data() {
    return {
      loading: false,
      contacto: null,
      // modal correo
      plantillasActivas: [],
      plantillaSeleccionada: null,
      variablesPlantilla: [],
      valoresVariables: {},
      enviando: false,
      asuntoLibre: '',
      contenidoLibre: '',
      adjuntosLibres: [],
      archivosAdjuntos: [],
      editorOptions: {
        theme: 'snow',
        placeholder: 'Escribe el contenido del correo aquí...',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            [{ header: 1 }, { header: 2 }],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            ['clean'],
            ['link']
          ]
        }
      },
    }
  },
  computed: {
    asuntoProcesado() {
      if (!this.plantillaSeleccionada) return ''
      return this.procesarTexto(this.plantillaSeleccionada.asunto, this.valoresVariables)
    },
    contenidoProcesado() {
      if (!this.plantillaSeleccionada) return ''
      return this.procesarTexto(this.plantillaSeleccionada.contenidoHtml, this.valoresVariables)
    }
  },
  mounted() {
    this.cargarContacto()
  },
  methods: {
    getInitials(name) {
      if (!name || typeof name !== 'string') return ''
      return name.split(' ').filter(Boolean).map(w => w.charAt(0)).join('').toUpperCase().substring(0, 2)
    },
    async cargarContacto() {
      try {
        this.loading = true
        const id = parseInt(this.$route.params.id)
        const data = await ContactoService.getById(id)
        this.contacto = data
      } catch (e) {
        this.$toast && this.$toast.error && this.$toast.error('Error al cargar el contacto')
        this.$router.push({ name: 'contactos-lista' })
      } finally {
        this.loading = false
      }
    },
    editarContacto() {
      this.$router.push({ name: 'contactos-editar', params: { id: this.$route.params.id } })
    },
    verEmpresa() {
      const id = this.contacto?.empresa?.idEmpresa || this.contacto?.idEmpresa
      if (id) this.$router.push({ name: 'empresas-detalle', params: { id } })
    },
    async enviarEmail() {
      if (!this.contacto?.email) return
      await this.cargarPlantillasActivas()
      this.$refs.modalEnviarCorreo.show()
    },
    onModalShow() {
      // Resetear estado como en la lista
      this.plantillaSeleccionada = null
      this.variablesPlantilla = []
      this.valoresVariables = {}
      this.asuntoLibre = ''
      this.contenidoLibre = ''
      this.adjuntosLibres = []
      this.archivosAdjuntos = []
    },
    onModalHidden() {
      // Limpieza adicional si fuese necesario
      this.enviando = false
      this.archivosAdjuntos = []
    },
    onFilesSelected(event) {
      const files = Array.from(event.target.files)
      this.archivosAdjuntos = [...this.archivosAdjuntos, ...files]
    },
    eliminarArchivo(index) {
      this.archivosAdjuntos.splice(index, 1)
    },
    limpiarArchivos() {
      this.archivosAdjuntos = []
      this.$refs.fileInput && (this.$refs.fileInput.value = '')
    },
    async cargarPlantillasActivas() {
      try {
        const plantillas = await plantillaCorreoService.getAllPlantillas()
        this.plantillasActivas = plantillas.filter(p => p.activa)
      } catch (e) {
        console.error('Error al cargar plantillas:', e)
        this.plantillasActivas = []
      }
    },
    onPlantillaSeleccionada(plantilla) {
      this.variablesPlantilla = []
      this.valoresVariables = {}
      if (!plantilla) return

      // Preferir objetos de variables si existen
      if (Array.isArray(plantilla.variables) && plantilla.variables.length > 0) {
        if (typeof plantilla.variables[0] === 'string') {
          const normalizadas = plantilla.variables
            .map(v => (typeof v === 'string' ? v.trim() : ''))
            .filter(v => v && v.length > 0)
          this.variablesPlantilla = normalizadas.map((nombre, idx) => ({
            id: `${nombre}_${idx}`,
            key: nombre,
            label: nombre,
          }))
          normalizadas.forEach(nombre => { this.valoresVariables[nombre] = '' })
        } else {
          this.variablesPlantilla = (plantilla.variables || [])
            .map((obj, idx) => {
              const key = obj?.nombreVariable || obj?.nombre
              return key ? ({ id: `${key}_${idx}`, key, label: key }) : null
            })
            .filter(Boolean)
          this.variablesPlantilla.forEach(v => { this.valoresVariables[v.key] = '' })
        }
        return
      }

      // Si no, parsear variablesDisponibles (JSON)
      if (typeof plantilla.variablesDisponibles === 'string' && plantilla.variablesDisponibles.trim().length > 0) {
        try {
          const vars = JSON.parse(plantilla.variablesDisponibles)
          if (Array.isArray(vars)) {
            const normalizadas = vars
              .map(v => (typeof v === 'string' ? v.trim() : ''))
              .filter(v => v && v.length > 0)
            this.variablesPlantilla = normalizadas.map((nombre, idx) => ({
              id: `${nombre}_${idx}`,
              key: nombre,
              label: nombre,
            }))
            normalizadas.forEach(nombre => { this.valoresVariables[nombre] = '' })
          }
        } catch (e) {
          console.warn('No se pudo parsear variablesDisponibles:', e)
          this.variablesPlantilla = []
        }
      }
    },
    procesarTexto(texto, variables) {
      if (!texto || !variables) return texto
      let resultado = texto
      Object.keys(variables).forEach(key => {
        const valor = variables[key] || ''
        const regex = new RegExp(`\\{\\{${key}\\}\\}`, 'g')
        resultado = resultado.replace(regex, valor)
      })
      return resultado
    },
    async procesarEnvio() {
      if (!this.contacto?.email) return
      try {
        this.enviando = true
        if (this.plantillaSeleccionada) {
          const formData = new FormData()
          formData.append('idPlantilla', this.plantillaSeleccionada.idPlantilla)
          formData.append('valoresVariables', JSON.stringify(this.valoresVariables))
          formData.append('destinatarios', JSON.stringify([this.contacto.email]))
          await plantillaCorreoService.procesarPlantillaConAdjuntos(formData)
        } else {
          if (this.adjuntosLibres.length > 0) {
            const formData = new FormData()
            formData.append('asunto', this.asuntoLibre || '')
            formData.append('contenidoHtml', this.contenidoLibre || '')
            formData.append('destinatarios', JSON.stringify([this.contacto.email]))
            this.adjuntosLibres.forEach(f => formData.append('adjuntos', f))
            await plantillaCorreoService.enviarCorreoLibreConAdjuntos(formData)
          } else {
            await plantillaCorreoService.enviarCorreoLibre({
              asunto: this.asuntoLibre || '',
              contenidoHtml: this.contenidoLibre || '',
              destinatarios: [this.contacto.email],
            })
          }
        }
        this.$refs.modalEnviarCorreo.hide()
      } catch (e) {
      } finally {
        this.enviando = false
      }
    },
    onFilesSelectedLibre(e) {
      const files = Array.from(e.target.files || [])
      this.adjuntosLibres = files
    },
    limpiarAdjuntosLibre() {
      this.adjuntosLibres = []
    },
    cerrarModal() {
      this.$refs.modalEnviarCorreo.hide()
    },
    llamarTelefono() {
      if (this.contacto?.telefono) {
        window.location.href = `tel:${this.contacto.telefono}`
      }
    },
    abrirLinkedIn() {
      if (this.contacto?.linkedin) {
        window.open(this.normalizarLinkedInUrl(this.contacto.linkedin), '_blank')
      }
    },
    normalizarLinkedInUrl(url) {
      if (!url) return ''
      
      // Si ya tiene protocolo, devolver tal cual
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url
      }
      
      // Si empieza con linkedin.com o www.linkedin.com, agregar https://
      if (url.startsWith('linkedin.com/') || url.startsWith('www.linkedin.com/')) {
        return `https://${url}`
      }
      
      // Si solo es un perfil (ej: "in/juan-perez" o "juan-perez"), construir la URL completa
      const perfil = url.replace(/^\/+/, '') // Quitar barras iniciales
      if (perfil.startsWith('in/')) {
        return `https://www.linkedin.com/${perfil}`
      }
      
      // Si no empieza con "in/", asumir que es un nombre de perfil
      return `https://www.linkedin.com/in/${perfil}`
    },
    eliminarContacto() {
      this.$swal({
        title: '¿Estás seguro?',
        text: `¿Deseas eliminar el contacto "${this.contacto.nombre}"?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-secondary ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          console.log('Eliminar contacto:', this.contacto.idContacto)
          this.$toast && this.$toast.success && this.$toast.success('Contacto eliminado correctamente')
          this.$router.push({ name: 'contactos-lista' })
        }
      })
    },
  }
}
</script>

<style scoped>
.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.content-header-title h2 {
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.content-subtitle {
  color: #6c757d;
  margin-bottom: 0;
}

.contact-info {
  padding: 1rem 0;
}

.contact-avatar {
  display: flex;
  align-items: center;
}

.contact-details {
  margin-top: 1rem;
}

.contact-item {
  display: flex;
  align-items: center;
}

.empresa-info {
  padding: 0.5rem 0;
}

.empresa-header h6 {
  font-weight: 600;
  color: #495057;
}

.gap-2 {
  gap: 0.5rem;
}
</style>

